const RoleEnum= {
       ADMIN: "Admin",
       STATUTORY: "Statutory",
       PRESIDENT: "President",
       MEMBER: "Member",
       USER: "User"
       
}

export default RoleEnum;